<script>
    export default {
        props: {
            languages: null,
            selectedLanguage: null,
            filter: null
        },
        data() {
            return {
                selectedLanguageMutable: this.selectedLanguage,
                filterMutable: this.filter,
                fields: {
                    productNameFilled: 'Produktname',
                    uspTextFilled: 'Katalog USP Text',
                    benefit1TextFilled: 'Benefit 1 Text',
                    benefit2TextFilled: 'Benefit 2 Text',
                    benefit3TextFilled: 'Benefit 3 Text',
                    onlineTextFilled: 'Online Text',
                    usp1TextFilled: 'USP 1 Text',
                    usp2TextFilled: 'USP 2 Text',
                    usp3TextFilled: 'USP 3 Text',
                    usp4TextFilled: 'USP 4 Text'
                },
                loading: false
            }
        },
        methods: {
            applyFilter() {
                let url = new URI(window.location.href);

                _.each(this.fields, (label, filter) => {
                    url.removeQuery(filter);

                    url.addQuery(filter, this.filterMutable[filter]);
                });

                window.location.href = url.toString();
            },
            removeFilter() {
                _.each(this.fields, (label, filter) => {
                    this.filterMutable[filter] = 0;
                });

                this.applyFilter();
            },
            updateLanguage(language) {
                this.loading = true;

                axios.post(Scoop.baseUrl + '/session', {
                    'key': 'selectedLanguage',
                    'value': language
                }).then(() => {
                    this.loading = false;
                });
            },
        },
        watch: {
            selectedLanguageMutable(language) {
                this.updateLanguage(language)
            }
        },
        computed: {
            filterActive() {
                return _.filter(this.fields, (label, key) => {
                    return this.filter[key] > 0;
                });
            }
        }
    }
</script>

<template>
    <div>
        <Lightbox
                id="filterTranslationProducts"
                headline="Text-Filter"
                :large="true"
        >
            <button slot="open-template" class="btn btn-xs btn-success pull-right">
                <span>Text-Filter</span>
                <small class="font-bold">{{ filterActive.length > 0 ? '[aktiv]' : '[inaktiv]' }}</small>
                <i class="fa fa-filter"></i>
            </button>
            <div slot="body" class="row">
                <div class="col-sm-12">
                    <label class="col-sm-2 control-label lh-34">Sprache</label>
                    <div class="col-sm-10">
                        <select class="form-control m-b" v-model="selectedLanguageMutable">
                            <option v-for="language in languages" :value="language.id">{{ language.language_name }}
                            </option>
                        </select>
                    </div>
                </div>
                <div class="hr-line-dashed col-sm-12 m-t-xs m-b-sm"></div>
                <div v-if="selectedLanguage" v-show="!loading">
                    <div v-for="(label,key) in fields" class="col-lg-6">
                        <div class="form-group">
                            <label class="col-lg-12 col-sm-2 control-label lh-34" v-text="label"></label>
                            <div class="col-lg-12 col-sm-10">
                                <select class="form-control m-b" v-model="filterMutable[key]">
                                    <option value="0">-</option>
                                    <option value="1">Befüllt</option>
                                    <option value="2">Leer</option>
                                </select>
                            </div>
                        </div>
                    </div>
                </div>
                <div v-show="loading" class="text-center">
                    <i class="fa fa-2x fa-cog fa-spin"></i>
                </div>
            </div>
            <div v-cloak slot="footer">
                <button class="btn btn-white pull-left" data-dismiss="modal"
                        style="margin-bottom: 0">Schließen
                </button>
                <div role="group" class="btn-group">
                    <div role="group" class="btn-group">
                        <button class="btn btn-white btn-sm" data-dismiss="modal" @click="removeFilter">
                            <span class="m-r-sm">Zurücksetzen</span>
                            <i class="fa fa-trash"></i>
                        </button>
                    </div>
                    <div role="group" class="btn-group">
                        <button class="btn btn-primary btn-sm" data-dismiss="modal" @click="applyFilter">
                            <span class="m-r-sm">Anwenden</span>
                            <i class="fa fa-filter"></i>
                        </button>
                    </div>
                </div>
            </div>
        </Lightbox>

    </div>
</template>